import EFPicture from 'elem/compCommon/EFPicture';
import IP68 from '@elem/SVGIcon/VanlifeRoadtrips/IP68';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import Clock from 'elem/SVGIcon/PowerBackup/Clock';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import IconInOne from './icons/inone';
import IconInstallation from './icons/installation';
import IconVariety from './icons/variety';

export default function G() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const LOCAL_SITES: string[] = ['kr'];
    const icons: any = [
        {
            icon: <IconInOne />,
            text: t('secG2_tag1'),
        },
        {
            icon: <IconInstallation />,
            text: t('secG2_tag2'),
        },
        {
            icon: <IconVariety />,
            text: t('secG2_tag3'),
        },
    ];
    return (
        <div id="vanlife-roadtrips-G2" className={`vanlife-roadtrips-G ${css['vanlife-roadtrips-G']}`}>
            <div className="img-box">
                <EFPicture
                    src={`https://websiteoss.ecoflow.com/upload/image/1750816735674/PC.jpg`}
                    srcMobile={`https://websiteoss.ecoflow.com/upload/image/1750817886863/20250625-101737.jpeg`}
                    alt={t('secG2_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secG2_title')}</p>
                    <p className="desc">{t('secG2_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
